import { render, staticRenderFns } from "./CreateParameter.vue?vue&type=template&id=19a6d008&scoped=true&"
import script from "./CreateParameter.vue?vue&type=script&lang=ts&"
export * from "./CreateParameter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a6d008",
  null
  
)

export default component.exports